import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useViewportSize } from "@mantine/hooks";
import { useBreakPoint } from "../../../hook/useBreakPoint";

export const FullPageContainer = ({
	children,
	bg,
	c,
	style,
	scale = 1,
	ref,
}) => {
	const { height } = useViewportSize();
	const initHeight = window.screen.availHeight;
	const { breakPoint, getResponsiveValue } = useBreakPoint();
	const [viewportHeight, setViewportHeight] = useState(initHeight);
	const containerHeight = {
		xs: "auto",
		sm: "auto",
		md: height===0?initHeight:height * scale,
		lg: height===0?initHeight:height * scale,
		xl: height===0?initHeight:height * scale,
	};

	useEffect(() => {
		setViewportHeight(height);
	},[height])



	return (
		<Box
			ref={ref}
			sx={{
				width: "100%",
				height: getResponsiveValue(containerHeight, breakPoint),
				minHeight: `${viewportHeight}px`,
				backgroundColor: bg,
				color: c,
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				...style,
			}}
		>
			{children}
		</Box>
	);
};